import * as React from "react";

const AnnouncementIcon: React.FC<React.SVGProps<SVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 30 30"
  >
    <path
      stroke="#313131"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M26.563 11.875h-1.875m-19.375 0h1.875m8.75-10.625v1.875M8.425 4.362 9.75 5.69m13.7-1.327L22.125 5.69m-5.366 2.078C11.246 12.578 5.31 18.629 3.203 20.81c-.494.51-.651 1.255-.367 1.905.155.353.338.738.528 1.066s.432.68.66.99c.42.572 1.144.807 1.833.636 2.943-.736 11.151-2.85 18.074-5.217"
    ></path>
    <path
      stroke="#313131"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M13.507 10.746s1.307 1.307 3.522 5.145c2.216 3.837 2.695 5.623 2.695 5.623m-5.54 1.834.372 1.386a2.87 2.87 0 1 1-5.544 1.485l-.309-1.155m7.575-18.126s1.498 1.638 4.479 6.8c2.98 5.164 3.65 7.28 3.65 7.28"
    ></path>
  </svg>
);

export default React.memo(AnnouncementIcon);
